<template>
  <sdDrawer
      ref="TemplateAddRef"
      :form="form"
      title="Template aanmaken"
      type="submit"
      btnText="Toevoegen"
      submitBtnText="Opslaan"
  >
    <FormValidationWrap>
      <a-form ref="formRef" :model="form" :rules="rules" layout="vertical" @finish="CreateTemplate">
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item label="Naam" name="name">
              <a-input v-model:value="form.name" placeholder=""/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Type" name="type">
              <a-select v-model:value="form.type" size="large" class="sDash_fullwidth-select" :allowClear="true">
                <a-select-option value="EMAIL">Email</a-select-option>
                <a-select-option value="PDF">PDF</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="HTML" name="html">
              <a-textarea v-model:value="form.html" :rows="10" placeholder=""/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item name="hasMargin">
              <a-checkbox v-model:checked="form.hasMargin">Heeft marge</a-checkbox>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <div class="sDash_form-action" style="margin-top: 16px;">
              <a-button type="primary" html-type="submit" size="large">
                Opslaan
              </a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </FormValidationWrap>
  </sdDrawer>
</template>
<script>
import {reactive, ref, defineComponent} from 'vue';
import {useStore} from 'vuex';
import {FormValidationWrap} from '../styled';
import {sdDrawer} from '../../components/modals/Modals';

const TemplateAdd = defineComponent({
  name: 'TemplateAdd',
  components: {FormValidationWrap, sdDrawer},
  setup() {
    const {dispatch} = useStore();
    const TemplateAddRef = ref(null);
    const formRef = ref(null);
    const form = reactive({
      name: null,
      html: '',
      type: null,
      productType: null,
      hasMargin: false,
    });
    const rules = {
      name: [{required: true, message: 'Dit veld is verplicht'}],
      type: [{required: true, message: 'Dit veld is verplicht'}],
      html: [{required: true, message: 'Dit veld is verplicht'}],
    };
    const CreateTemplate = () => {
      dispatch('createTemplate', {
        value: form,
        close: () => {
          TemplateAddRef.value.handleCancel();
        },
      });
    };
    return {
      form,
      rules,
      formRef,
      TemplateAddRef,
      CreateTemplate,
    };
  },
});

export default TemplateAdd;
</script>

